
import { css } from 'lit';
export default css`
:host{
  --pc-header-primary-color:var(--primary-eggplant);
  --pc-header-ancillary-color:var(--neutral-dark-eggplant);

  display:block;
  position:relative;
  z-index:10;
}
  @media print{:host{
    display:none
}
  }

.header{
  background-color:var(--pc-header-primary-color);
}

.content{
  display:flex;
  justify-content:space-between;
  align-items:center;
  box-sizing:border-box;
  padding-top:var(--spacing-4);
  padding-bottom:var(--spacing-4);
  height:74px;
}

::slotted([slot='utility']){
  display:none;
}

.actions{
  display:flex;
  align-self:center;
  gap:var(--spacing-6);
}

.menu-trigger{
  display:inline-flex;
  justify-content:center;
  align-items:center;
  border:none;
  background:transparent;
  padding:0;
  color:var(--primary-white);
}

.search-trigger{
  min-width:41px;
  width:41px;
  height:41px;
  background-color:var(--purple-indigo);
  border:0;
  color:white;
  display:inline-flex;
  justify-content:center;
  align-items:center;
  border-radius:100%;
  cursor:pointer;
}

.overlay{
  display:none;
}

@media (max-width: 991px){
  .menu-trigger pc-icon[name='xmark-large']{
    display:none;
  }

  .menu-trigger.is-expanded pc-icon[name='bars']{
    display:none;
  }

  .menu-trigger.is-expanded pc-icon[name='xmark-large']{
    display:block;
  }

  .overlay{
    display:none;
    position:absolute;
    top:74px;
    right:0;
    bottom:0;
    left:0;
    opacity:0.15;
    background-color:var(--neutral-charcoal);
  }

  .primary-section{
    display:none;
    position:absolute;
    top:74px;
    right:0;
    left:0;
  }

  .search-section.is-expanded,
  .primary-section.is-expanded{
    display:block;
  }
}

.search-section{
  position:absolute;
  background-color:white;
  right:0;
  left:0;
  top:0;
  padding:2rem;
  display:none;
  box-shadow:0px 4px 4px 0px #5b496c33;
}

.search-section .inner{
    display:flex;
    justify-content:center;
    gap:2rem;
    max-width:1440px;

    margin:0px auto;
    padding:2rem;
  }

.search-section .search-trigger{
    transition:ease 0.3s;
  }

.search-section .search-trigger:hover{
    background-color:var(--primary-eggplant);
  }

.search-section .search-trigger:focus{
    color:var(--primary-eggplant);
    outline:2px solid var(--purple-indigo);
    background-color:var(--purple-indigo-light);
  }

.search-section.is-expanded{
  display:block;
}

@media (max-width: 992px){
  .search-section{
    padding:1rem 2rem;
  }
    .search-section .inner{
      flex-wrap:wrap;
      position:relative;
      padding:0;
    }

    .search-section .search-logo{
      display:none;
    }

    .search-section .search-trigger{
      position:absolute;
      top:10px;
      right:0;
    }
}

@media (min-width: 992px){
  .search-section{
    min-height:150px;
  }
    .search-section .inner{
      gap:4rem;
    }

  .search{
    width:100%;
  }
  ::slotted([slot='search']){
    padding:0 10%;
  }
}

@media (min-width: 1279px){
  .search{
    flex-basis:75%;
  }
}

@media (min-width: 768px) and (max-width: 991px){
  .primary-section{
    left:auto;
    width:554px;
  }
}

@media (min-width: 992px) and (max-width: 1279px){
  .content::before{
    content:'';
  }

  ::slotted([slot='logo']){
    position:absolute;
    top:24px;
    left:auto;
  }
}

@media (min-width: 992px){
  .content{
    height:148px;
    padding-top:var(--spacing-6);
    padding-bottom:var(--spacing-6);
  }

  .links-section{
    display:flex;
    flex-direction:column;
    align-items:flex-end;
    gap:var(--spacing-6);
  }

  .utility-section{
    display:flex;
    align-items:center;
    gap:var(--spacing-8);
  }

  .menu-trigger{
    display:none;
  }

  ::slotted([slot='utility']){
    display:block;
  }
}
`;